module.exports = __webpack_public_path__ + "static/premiumreisen-d212f2aba19d9af3af6708e2e2ae86b7.svg";